import React, {useEffect, useState} from "react";
import {Checkbox, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import TextFieldValidation from "../../../../../components/UI/table/customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import Customers from "../../../orders/Customers";
import ButtonExit from "../../../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../../../components/UI/button/ButtonAdd";
import FormControlLabel from "@mui/material/FormControlLabel";
import {Box} from "@mui/system";

const MarginModal = ({marginModal, onClose, handleSubmit, initValue, title, allOrderTypes,loading}) => {
    const [formState, setFormState] = useState({margin: "", orderType: allOrderTypes[0][0], current: true})
    const [validationState, setValidationState] = useState({margin: ""})
    const [selectedString, setSelectedString] = useState({})

    useEffect(() => {
        setFormState(initValue)
    }, [initValue])

    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(formState).forEach(([name, value]) => {
            if (value === "") {
                newErrors[name] = "пустое поле"
            }
        })
        setValidationState(newErrors)
        if (Object.values(newErrors).every(el => el === "")) {
            const autocorrectMargin = formState.margin.replace(/,/, '.')
            if (marginModal === "addMarginToType") {
                handleSubmit({...formState, margin: autocorrectMargin})
            } else {
                handleSubmit({
                    ...formState,
                    margin: autocorrectMargin,
                    customerId: selectedString?.id,
                    customerName: selectedString?.name
                })
            }
        }
    }
    return (
        <Dialog open={marginModal} PaperProps={{
            style: {
                minWidth: initValue?.id || marginModal === "addMarginToType" ? "400px" : "800px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent>
                <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <Box sx={{width: "400px"}}>
                        <TextFieldValidation
                            name={"margin"}
                            label={"Наценка"}
                            value={formState?.margin}
                            setCurrValues={setFormState}
                            validationError={validationState?.margin}
                            setValidationState={setValidationState}
                        />
                    </Box>
                </Box>

                {initValue?.id && <FormControlLabel
                    control={<Checkbox
                        onChange={() => setFormState(prev => ({...prev, current: !prev.current}))}
                        checked={formState?.current}
                    />}
                    label="Активна"
                />}
                {!initValue?.id && (marginModal === "addMarginToType" ?
                    <TextFieldValidation
                        select
                        name="orderType"
                        label="Тип заказа"
                        value={formState.orderType}
                        setCurrValues={setFormState}
                    >
                        {allOrderTypes.map((option) => (
                            <MenuItem key={option[0]} value={option[0]}>
                                {option[1]}
                            </MenuItem>
                        ))}
                    </TextFieldValidation> :
                    <Customers
                        isModal={true}
                        selectedStringId={selectedString?.id}
                        setSelectedString={setSelectedString}/>)}
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={onClose}/>
                <ButtonAdd
                    loading={loading}
                    text={initValue?.id ? "Изменить" : "Добавить"}
                           disabled={!initValue?.id && marginModal === "addMarginToCustomer" && !selectedString?.id}
                           onClick={handleValidationData}/>
            </DialogActions>
        </Dialog>
    );
}
export default MarginModal